import { StaticBaseDao } from '@/dao';
import {
    EventProductionDevice,
    ProductionDeviceSetting,
    ProductionTableDef,
    ProductionDisplayData,
    ProductionEvent,
} from '@/objects/generated';

export class ProductionDao extends StaticBaseDao {
    public static async AssignDeviceToEvent(productionDevice: EventProductionDevice, eventID: number): Promise<number | null> {
        return this.Post(`Production/AssignDeviceToEvent` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`), productionDevice);
    }
    public static async GetEventProductionDevices(EventID: number): Promise<EventProductionDevice[]> {
        return this.BaseFetchArray(
            EventProductionDevice,
            `Production/GetEventProductionDevices` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async DeleteEventProductionDevice(productionDevice: EventProductionDevice, EventID: number): Promise<number | null> {
        return this.Post(
            `Production/DeleteEventProductionDevice` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            productionDevice,
        );
    }
    public static async PublishDeviceSetting(setting: ProductionDeviceSetting, EventID: number): Promise<boolean | null> {
        return this.Post(`Production/PublishDeviceSetting` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), setting);
    }
    public static async ProductionDeviceIsAlive(setting: ProductionDeviceSetting, EventID: number): Promise<boolean | null> {
        return this.Post(`Production/ProductionDeviceIsAlive` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), setting);
    }
    public static async GetProductionDisplayData(definition: ProductionTableDef, EventID: number): Promise<ProductionDisplayData | null> {
        return this.BaseFetch(
            ProductionDisplayData,
            `Production/GetProductionDisplayData` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            definition,
        );
    }
    public static async GetProductionEvent(EventID: number): Promise<ProductionEvent | null> {
        return this.BaseFetch(
            ProductionEvent,
            `Production/GetProductionEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
}
